import {
  GET_ACTIVE_ADDRESSES_DROPDOWN_REQUEST,
  GET_BENFITS_DROPDOWN_REQUEST,
  GET_EQUIPMENT_PROFICIENCY_DROPDOWN_REQUEST,
  GET_FOCUS_AREA_DROPDOWN_REQUEST,
  GET_JOB_CITY_DROPDOWN_REQUEST,
  GET_JOB_DETAILS_REQUEST,
  GET_PAY_COMMISSION_DROPDOWN_REQUEST,
  GET_ROLETIRS_DROPDOWN_REQUEST,
  GET_SKILS_DROPDOWN_REQUEST,
  GET_SOFT_SKILLS_DROPDOWN_REQUEST,
  GET_SPECIALZATION_DROPDOWN_REQUEST,
  SAVE_APPLY_JOBS_REQUEST,
  SAVE_BASIC_JOB_DETAILS_REQUEST,
  SAVE_JOB_DETAILS_SUCCESS,
  SAVE_UPDATE_JOB_STATUS_REQUEST,
  VIEW_JOB_DETAILS_STATUS_REQUEST,
  GET_HOSPITAL_BASIC_INFO_REQUEST,
  GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST,
  GET_HOSPITAL_OWNERSHIP_INFO_REQUEST,
  GET_HOSPITAL_OTHER_DETAILS_REQUEST,
  GET_HOSPITAL_HOSTEL_DETAILS_REQUEST,
  GET_HOSPITAL_SOCIAL_INFO_REQUEST,
  GET_HOSPITAL_DOCUMENT_INFO_REQUEST,
} from "./hospitalManagement.type";

export const getJobDetailsRequest = (user, companyTypeId, callback) => ({
  type: GET_JOB_DETAILS_REQUEST,
  payload: { user, companyTypeId },
  callback,
});

export const saveJobDetailsRequest = (payload, callback) => ({
  type: SAVE_BASIC_JOB_DETAILS_REQUEST,
  payload,
  callback,
});

export const getSkillsDropdownRequest = (payload, callback) => ({
  type: GET_SKILS_DROPDOWN_REQUEST,
  payload,
  callback,
});
export const getSpecializationDropdownRequest = (payload, callback) => ({
  type: GET_SPECIALZATION_DROPDOWN_REQUEST,
  payload,
  callback,
});
export const getDistinctJobCitiesDropdownRequest = (payload, callback) => ({
  type: GET_JOB_CITY_DROPDOWN_REQUEST,
  payload,
  callback,
});


export const saveJobDetailsSuccess = (payload, callback) => ({
  type: SAVE_JOB_DETAILS_SUCCESS,
  payload,
  callback,
});

export const getCorporateBenefitsDropdownRequest = (payload, callback) => ({
  type: GET_BENFITS_DROPDOWN_REQUEST,
  payload,
  callback,
});

export const getRoleTiresDropdownRequest = (payload, callback) => ({
  type: GET_ROLETIRS_DROPDOWN_REQUEST,
  payload,
  callback,
});
export const getPayCommissionDropdownRequest = (payload, callback) => ({
  type: GET_PAY_COMMISSION_DROPDOWN_REQUEST,
  payload,
  callback,
});
export const getFocusAreaDropdownRequest = (payload, callback) => ({
  type: GET_FOCUS_AREA_DROPDOWN_REQUEST,
  payload,
  callback,
});
export const getSoftSkilsDropdownRequest = (payload, callback) => ({
  type: GET_SOFT_SKILLS_DROPDOWN_REQUEST,
  payload,
  callback,
});

export const getEquipmentDropdownRequest = (payload, callback) => ({
  type: GET_EQUIPMENT_PROFICIENCY_DROPDOWN_REQUEST,
  payload,
  callback,
});

export const saveJobStatusRequest = (user, status, callback) => ({
  type: SAVE_UPDATE_JOB_STATUS_REQUEST,
  payload: { user, status },
  callback,
});


export const viewJobDetailsRequest = (user, callback) => ({
  type: VIEW_JOB_DETAILS_STATUS_REQUEST,
  payload: { user },
  callback,
});



export const applyJobRequest = (payload, callback) => ({
  type: SAVE_APPLY_JOBS_REQUEST,
  payload,
  callback,
});

export const getAddressDetailsIdsDropdownRequest = (payload, callback) => ({
  type: GET_ACTIVE_ADDRESSES_DROPDOWN_REQUEST,
  payload,
  callback,
});

export const getHospitalBasicInfoRequest = (id, callback) => ({
  type: GET_HOSPITAL_BASIC_INFO_REQUEST,
  payload: { id },
  callback,
});

export const getHospitalDemographicInfoRequest = (id, callback) => ({
  type: GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST,
  payload: { id },
  callback,
});

export const getHospitalOwnershipInfoRequest = (id, callback) => ({
  type: GET_HOSPITAL_OWNERSHIP_INFO_REQUEST,
  payload: { id },
  callback,
});

export const getHospitalOtherDetailsRequest = (id, callback) => ({
  type: GET_HOSPITAL_OTHER_DETAILS_REQUEST,
  payload: { id },
  callback,
});

export const getHospitalHostelDetailsRequest = (id, callback) => ({
  type: GET_HOSPITAL_HOSTEL_DETAILS_REQUEST,
  payload: { id },
  callback,
});

export const getHospitalSocialInfoRequest = (id, callback) => ({
  type: GET_HOSPITAL_SOCIAL_INFO_REQUEST,
  payload: { id },
  callback,
});

export const getHospitalDocumentInfoRequest = (id, callback) => ({
  type: GET_HOSPITAL_DOCUMENT_INFO_REQUEST,
  payload: { id },
  callback,
});